// @flow

import React from 'react'
import Tooltip from './Tooltip'

type Props = {
  children?: React$Node,
  className?: string,
  colorClass?: string,
  arrowClass?: string,
  backgroundClass?: string,
  tip: React$Node,
}

type State = {
  open: boolean,
}

export default class ClickTooltip extends React.Component<Props, State> {
  state = {
    open: false,
  }

  toggleOpen() {
    this.setState({ open: !this.state.open })
  }

  render() {
    const {
      children,
      className = '',
      colorClass = '',
      arrowClass = '',
      backgroundClass = '',
      tip,
    } = this.props

    return (
      <div
        className={`${className} relative `}
        onClick={() => this.toggleOpen()}
      >
        {children}
        <Tooltip
          show={this.state.open}
          colorClass={colorClass}
          arrowClass={arrowClass}
          backgroundClass={backgroundClass}
        >
          {tip}
        </Tooltip>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/ClickTooltip.js